import { useEffect } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function usePWAUpdate() {
    const {
        offlineReady: [offlineReady, _setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegisteredSW(swUrl, r) {
            console.log(`SW Registered: ${swUrl}`);
            if (r) {
                // Check for updates every hour
                setInterval(() => {
                    if (!(!r.installing && !r.waiting)) return;
                    if (('connection' in navigator) && !navigator.onLine) return;

                    console.log("Checking for SW update...");
                    r.update();
                }, 60 * 60 * 1000);
            }
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    useEffect(() => {
        if ('serviceWorker' in navigator) {
            const handleControllerChange = () => {
                console.log("SW controller changed, reloading page...");
                window.location.reload();
            };
            navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);
            return () => {
                navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
            };
        }
    }, []);

    return {
        offlineReady,
        needRefresh,
        updateServiceWorker,
        setNeedRefresh // exposed for dimiss "later"
    };
}
